// Pay changes are recorded as a new dated revision; an old pay row is never edited in place,
// because pay records are kept (triage G14, FE-06-03).
export function payNeedsNewRevision(latest, payload) {
  // A first pay row needs real pay. Editing someone's city must not give them a base pay 0 row that then
  // becomes their latest profile and shows as zero on payslips (triage FE-06-04).
  if (!latest) return Number(payload.base_pay || 0) > 0;
  return (
    Number(latest.base_pay || 0) !== Number(payload.base_pay || 0) ||
    String(latest.pay_type || "Fixed") !== String(payload.pay_type || "Fixed") ||
    Number(latest.performance_pay || 0) !== Number(payload.performance_pay || 0)
  );
}
